export const MODALS__MERGE = 'MODALS__MERGE';
export const merge = ({ modals }) => ({ type: MODALS__MERGE, modals });

export const MODALS__REMOVE = 'MODALS__REMOVE';
export const remove = ({ name }) => ({ type: MODALS__REMOVE, name });
